"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMethod = exports.InterviewTakenBy = exports.Sex = exports.RaceIslander = exports.RaceAsian = exports.Race = exports.EthnicityHispanic = exports.EthnicityName = exports.Ethnicity = void 0;
var Ethnicity;
(function (Ethnicity) {
    Ethnicity["HISPANIC"] = "1";
    Ethnicity["NOHISPANIC"] = "2";
    Ethnicity["NOSHARE"] = "NO_SHARE";
})(Ethnicity = exports.Ethnicity || (exports.Ethnicity = {}));
var EthnicityName;
(function (EthnicityName) {
    EthnicityName["HISPANIC"] = "Hispanic";
    EthnicityName["NOHISPANIC"] = "Not Hispanic";
    EthnicityName["NOSHARE"] = "NO_SHARE";
})(EthnicityName = exports.EthnicityName || (exports.EthnicityName = {}));
var EthnicityHispanic;
(function (EthnicityHispanic) {
    EthnicityHispanic["MEXICAN"] = "Mexican";
    EthnicityHispanic["PUERTO"] = "Puerto Rican";
    EthnicityHispanic["CUBAN"] = "Cuban";
    EthnicityHispanic["OTHER"] = "Other";
})(EthnicityHispanic = exports.EthnicityHispanic || (exports.EthnicityHispanic = {}));
var Race;
(function (Race) {
    Race["AFRICAN"] = "Black or African American";
    Race["ASIAN"] = "Asian";
    Race["ISLANDER"] = "Native Hawaiian or Other Pacific Islander";
    Race["NATIVE"] = "American Indian or Alaska Native";
    Race["WHITE"] = "White";
    Race["NOSHARE"] = "NO_SHARE";
})(Race = exports.Race || (exports.Race = {}));
var RaceAsian;
(function (RaceAsian) {
    RaceAsian["INDIAN"] = "Asian Indian";
    RaceAsian["CHINESE"] = "Chinese";
    RaceAsian["FILIPINO"] = "Filipino";
    RaceAsian["JAPANESE"] = "Japanese";
    RaceAsian["KOREAN"] = "Korean";
    RaceAsian["VIET"] = "Vietnamese";
    RaceAsian["OTHER"] = "Other";
})(RaceAsian = exports.RaceAsian || (exports.RaceAsian = {}));
var RaceIslander;
(function (RaceIslander) {
    RaceIslander["NATIVE"] = "Native Hawaiian";
    RaceIslander["GUAM"] = "Guamanian or Chamorro";
    RaceIslander["SAMOAN"] = "Samoan";
    RaceIslander["OTHER"] = "Other";
})(RaceIslander = exports.RaceIslander || (exports.RaceIslander = {}));
var Sex;
(function (Sex) {
    Sex["MALE"] = "M";
    Sex["FEMALE"] = "F";
    Sex["NOSHARE"] = "NO_SHARE";
})(Sex = exports.Sex || (exports.Sex = {}));
var InterviewTakenBy;
(function (InterviewTakenBy) {
    InterviewTakenBy["FACE_TO_FACE"] = "Face to Face";
    InterviewTakenBy["INTERNET_OR_EMAIL"] = "Internet or Email";
    InterviewTakenBy["MAIL_OR_FAX"] = "Mail or Fax";
    InterviewTakenBy["VIDEO_CONFERENCE"] = "Video Conference";
})(InterviewTakenBy = exports.InterviewTakenBy || (exports.InterviewTakenBy = {}));
var CollectionMethod;
(function (CollectionMethod) {
    CollectionMethod["VISUAL"] = "Visual Observation or Surname";
    CollectionMethod["NOT_VISUAL"] = "Not Visual Observation or Surname";
    CollectionMethod["NOT_APPLICABLE"] = "Not Applicable";
})(CollectionMethod = exports.CollectionMethod || (exports.CollectionMethod = {}));
